import api from "./Api";

class PedidoItemService {
  GetPedidoItem(payload) {
    return api.get("/v1/pedidoItem/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPedidoItem(payload) {
    return api.post("/v1/pedidoItem/", payload).then((response) => {
      return response.data;
    });
  }

  PutPedidoItem(payload) {
    return api.put("/v1/pedidoItem/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePedidoItem(payload) {
    return api.delete("/v1/pedidoItem/" + payload).then((response) => {
      return response.data;
    });
  }

  GetPedidoItemOData(payload) {
    return api.get("/OData/PedidoItem" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new PedidoItemService();
